import tenants from "./tenants";


let base_url;
if (process.env.NODE_ENV === "development") {
  base_url = {
    protocol: "http",
    hostname: "localhost",
    port: "8000",
    api_base_path: "/",
  };
} else {
  const host = window.location.hostname;
  const tenantKey = host.split(".")[1];

  let hostName = tenants[tenantKey]?.hostName || "floorwalk.in";
  base_url = {
    protocol: "https",
    hostname: `portal.${hostName}`,
    port: "",
    api_base_path: "/",
  };
}
export { base_url };


// export const base_url = {
// 	protocol : "https",
// 	hostname : "portal.floorwalk.in",
// 	hostname : "portal.hsbrandsasia.com",
// 	port : "",
// 	api_base_path: "/",
// };